import type { FeatureGroup } from '../../../types';
import { CRM_INTEGRATIONS_FEATURE_GROUP } from '../group';

export const DEDUPER_FEATURE_GROUP: FeatureGroup = {
  guid: '225d571d-1b8d-40a8-9de0-ffdb512bff00',
  name: 'deduper',
  description: 'Deduper app — identify and merge duplicate records',
  product: 'app',
  parentGuid: CRM_INTEGRATIONS_FEATURE_GROUP.guid,
};
